import { stringOfEnum } from "@omnia/shared/utils/utils";
import { defineDirective, handleApiError, IOmniaShell, IUibModalScope, shell } from "../../../omnia"
import { INutritionTemplate, INutritionTemplateApp, IPlanTemplateService, NutrientType, ProductAppInput } from "../../../types"

export class TemplateManagePopupCtrl extends shell.Dialog {

    static create(): ng.IDirective {

        return defineDirective(TemplateManagePopupCtrl, "app/nutrition/plan/edit/template/template-manage.html", {});

    }

    static $inject = ["$scope", "OmniaNutritionPlanTemplateService", "OmniaShell"];

    private templates: INutritionTemplate[];
    private canLoadTemplate: boolean;

    constructor($scope: ng.IScope, private svc: IPlanTemplateService, shell: IOmniaShell) {
        super($scope, shell);
        this.$scope = <IUibModalScope>$scope.$parent;

        this.canLoadTemplate = !!this.arguments;

        this.refresh();
    }

    private refresh() {
        this.svc.getTemplates().then(r => this.templates = r);
    }

    loadTemplate(template: INutritionTemplate) {

        this.close(template);

    }

    deleteTemplate(template: INutritionTemplate) {

        shell.showDeleteCancel(this.shell, "Are you sure that you want to delete this template ?", "Delete warning").then(r => {
            if (r) {

                this.svc.deleteTemplate(template.NutritionPlanTemplateId)
                    .then(r => this.refresh())
                    .catch(e => handleApiError(this.shell, e))


            }
        });

    }

    private getTooltip(template: INutritionTemplate): string {
        return template.Applications.map(a => a.FertiliserProduct.Name +
            " " +
            getProductRateTxt(a) +
            " - " +
            getShortDateText(a.ApplicationDate)).join("<br/>");
    }

}

function getProductRateTxt(app: INutritionTemplateApp): string {

    if (app.Complete) {
        return "Complete " + stringOfEnum(NutrientType, app.TargetNutrient);
    }

    var rate = app.Rate;
    var unit = app.FertiliserProduct.Liquid ? "m<sup>3</sup>" : "kg";

    if (app.ProductAppInput === ProductAppInput.ProductRate) {
        unit += "/ha";
    } else if (app.ProductAppInput === ProductAppInput.NutrientRate) {
        unit += " of " + stringOfEnum(NutrientType, app.TargetNutrient);
    } else {
        rate = rate * 100;
        unit = "% of " + stringOfEnum(NutrientType, app.TargetNutrient);
    }

    return rate + unit;
}

function getShortDateText(date: Date) {

    var day = date.getDate();
    var dayTxt = day < 10 ? "0" + day.toString() : day.toString();

    var month = date.getMonth() + 1;
    var monthTxt = month < 10 ? "0" + month.toString() : month.toString();

    return dayTxt + "/" + monthTxt;
}
